import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getString } from "../../utilities";
import Hamburger from "../../../assets/svg/hamburger.svg";
import Magnify from "../../../assets/svg/magnifySearchField.svg";
import { isLoggedInSelector, modalToggle } from "../../redux/slices/loginSlice";

export default function SmallNav({ setHasSearch, hasSearch, setHasMenu, hasMenu }) {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const dispatch = useDispatch();

  return (
    <div className="header-nav-small">
      <div className="menubtn-container">
        <a
          className={hasMenu ? "active" : ""}
          onClick={() => {
            setHasMenu((prevHasMenu) => !prevHasMenu);
            setHasSearch(false);
          }}
        >
          {getString("navigation.menu")}
          <Hamburger />
        </a>
      </div>

      <div className="searchbtn-container">
        <a
          className={hasSearch ? "active" : ""}
          onClick={() => {
            setHasSearch((prevHasSearch) => !prevHasSearch);
            setHasMenu(false);
          }}
        >
          {getString("navigation.search")}
          <Magnify />
        </a>
      </div>

      <a
        onClick={() => {
          setHasMenu(false);
          setHasSearch(false);
          dispatch(modalToggle());
        }}
      >
        {isLoggedIn ? getString("navigation.logout.3", [], true) : getString("navigation.login.2", [], true)}
      </a>
    </div>
  );
}

SmallNav.propTypes = {
  setHasMenu: PropTypes.func.isRequired,
  hasMenu: PropTypes.bool.isRequired,
  setHasSearch: PropTypes.func.isRequired,
  hasSearch: PropTypes.bool.isRequired,
};
